<template>
  <div class="colors">
    <div
      v-if="swatchVisible"
      class="color-swatch py-3 d-flex flex-wrap mx-auto"
    >
      <div
        class="theme-color theme-color--new d-flex flex-column align-items-center justify-content-around"
        @click.stop.prevent="addNewColorShowPicker"
      >
        <i class="material-icons">add</i>
         <small>{{ $t("elements.properties.color.add") }}</small>
      </div>

      <div
        v-if="usage !== 'SapSiteSettings'"
        class="theme-color theme-color--new d-flex flex-column align-items-center justify-content-around"
        @click.stop.prevent="applyColorsAll({colorId: null, toBg: toBg})"
      >
        <i class="material-icons">format_color_reset</i>
         <small>{{ $t("elements.properties.color.clear") }}</small>
      </div>

      <div 
        v-for="(color, key) in colors"
        :key="key"
        class="theme-color theme-color--editable"
        :style="colorToStyle(color)"
        @click.stop="applyColorsAll({colorId: key, toBg: toBg})"
      >
        <div
          class="theme-color__edit__btn"
          @click.stop="enableColorPicker(color, key)"
        >
          {{ $t("editor.right_nav.theme.color_picker.edit.btn") }}
        </div>
      </div>
    </div>
    <div
      v-else-if="colorPickerVisible"
      class="color-picker"
    >
      <div class="row no-gutters">
        <div class="col-auto">
          <color-picker
            ref="picker"
            @change="updateCurrentColor"
          />
        </div>
      </div>

      <div v-if="usage === ''" class="divider" />

      <div 
        v-if="usage === ''"
        class="row no-gutters"
      >
        <div class="col">
          <button
            class="btn btn-success btn-block"
            @click.prevent.stop="disableColorPicker"
          >
            {{ $t("editor.right_nav.theme.color_picker.save.btn") }}
          </button>
        </div>
        <div class="col-auto mx-1" />
        <div class="col">
          <button
            class="btn btn-danger btn-block"
            @click.prevent.stop="removeColorPrompt"
          >
            {{ $t("editor.right_nav.theme.color_picker.delete.btn") }}
          </button>
        </div>
      </div>

      <div 
        v-if="usage === 'SapSiteSettings'"
        class="row no-gutters"
      >
        <div class="col">
          <button
            class="btn btn-success site-settings-btns"
            @click.prevent.stop="disableColorPicker"
          >
            {{ $t("editor.right_nav.theme.color_picker.save.btn") }}
          </button>

           <button
            class="btn btn-danger site-settings-btns"
            @click.prevent.stop="removeColorPrompt"
          >
            {{ $t("editor.right_nav.theme.color_picker.delete.btn") }}
          </button>
        </div>
      </div>

    </div>

    <div
      v-if="alpha && swatchVisible"
      class="row"
    >
      <div class="col-auto d-flex align-items-center">
        <h6 :class="textColorClass">{{ $t("elements.properties.color.transparency") }}</h6>
      </div>
      <div class="col">
        <cvt-slider
          id="slider-default"
          :tooltips-enabled="true"
          :step-marks-enabled="true"
          class="slider"
          :min="0"
          :max="1"
          :value="transparencyVal"
          :step="0.1"
          @change="onChange"
        />
      </div>
    </div>

  </div>
</template>
<script>

import color from 'color';
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import * as actions from "../../../store/modules/actions";
import * as getters from "../../../store/modules/getters";

import ColorPicker from '../../../components/spectrum/ColorPicker.vue';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Colors',
  components: {
    ColorPicker
  },
  props: {
    alpha: Boolean,
    mode: {
      type: String,
      default: 'LIGHT'
    },
    toBg: {
      type: Boolean,
      default: false
    },
    usage: {
      type: String,
      default: ''
    },
    customOptions: {
      type: Object,
      default () { return { bindSelected: true, transparency: 1, activeColor: '' } }
    },
  },

  data () {
    return {
      colorPickerVisible: false,
      currentColor: color('white'),
      currentKey: null,
      removeColorVisisble: false,
      alphaChannel: 1,
      exclude: {
        "GridBoxContainer": true,
        "Icon": true
      }
    }
  },

  computed: {
    ...mapGetters({
      // colors: getters.SAP_THEME_BRAND_COLORS,
      colors: getters.THEME_GET_COLORS,
      // defaultColor: getters.THEME_DEFAULT_COLOR,
      // selected: getters.SELECTOR_SELECTED,
      // config: getters.AUTH_GET_USER_CONFIG,
      // isGridBuilder: getters.SITE_HAS_GRIDBUILDER
    }),

    swatchVisible () {
      return this.colorPickerVisible === false
    },

    saveBtnMsg () {
      return this.currentKey ? 'Save' : 'Add'
    },

    textColorClass () {
      return {'text-white': this.mode=='DARK'}
    },
    transparencyVal(){
      if( this.customOptions.bindSelected ) {
        return this.alphaChannel;
      } else{
        return this.customOptions.transparency;
      }
    }
  },

  created () {
    this.alphaChannel = this.selected?.themeColorAlpha || 1
  },
  methods: {
    ...mapActions({
      addNewThemeColor: actions.THEME_ADD_NEW_COLOR,
    }),


    removeColorPrompt () {
      this.$confirm(
        this.$t("editor.right_nav.theme.color_picker.delete.confirmation.warning"),
        'Warning', {
          type: 'danger',
          cancelButtonText: this.$t('marketplace.dialog.archive.cta.cancel'),
          confirmButtonText: this.$t('marketplace.dialog.archive.cta.submit'),
          confirmButtonClass: 'el-button--danger'
      }).then(() => {
        return this.removeColor(this.currentKey)
      }).then(this.disableColorPicker).catch((err) => {
        if (err !== 'cancel') {
          console.log(err)
          this.$message({ type: 'info', message: this.$t("editor.right_nav.theme.color_picker.delete.failed.message") })
        }
      })
    },

    addNewColorShowPicker () {
      this.currentColor = color('white')
      // this.addNewThemeColor(this.currentColor).then((colorId) => {
      //   this.enableColorPicker(this.currentColor, colorId)
      //   return this.applyColorsAll({colorId: colorId, toBg: this.toBg})
      // })
    },

    enableColorPicker (color, key) {

      this.currentKey = key
      this.currentColor = color
      this.colorPickerVisible = true

      // usage prop will always be equal to empty-string except 
      // when this component is being rendered in "Landing Page SiteSettings" component
      if(this.usage === '') {
        this.$nextTick(_ => {
          this.$refs.picker.setColor(this.currentColor)
        });
      }
    },

    disableColorPicker () {
      this.colorPickerVisible = false
      this.removeColorVisisble = false
    },

    updateCurrentColor: _.debounce(function (color) {
      this.currentColor = color

      // return this.updateThemeColor({
      //   color: this.currentColor,
      //   key: this.currentKey
      // });

      console.log(this.currentColor);
      console.log(this.currentKey);

    }, 300),

    colorToStyle (color) {
      return {
        backgroundColor: color.hsl().toString()
      }
    },

    onChange (value) {
      // if( this.customOptions.bindSelected ) {
      //   this.alphaChannel = value;
      //   this.updateProp({
      //     key: 'themeColorAlpha',
      //     value
      //   });
      // } else {
      //   this.$emit( 'apply-transparency', value );
      // }
    },

    applyColorsAll (options) {

      if(this.usage === 'SapSiteSettings') { return; }
      
      // if( this.customOptions.bindSelected) 
      // {
      //   return this.applyColorToSelected( options );
      // } 
      // else 
      // {
      //   this.$emit( 'apply-color', options );
      // }
    }
  }
}
</script>

<style lang="scss">
  // @import "utils";
  @import "@/scss/utils";



  .theme-color__edit__btn {
    transition: all 250ms ease;
    display: none;
    top: -10px;
    right: -10px;
    position: absolute;
    box-shadow: 0 0 0 2px rgba(63,70,82,.15);
    background: $white;
    border-radius: 3px;
    border: 1px solid $dark;
    color: $dark;
    z-index: 3;
    padding: 0 5px;
    text-align: center;

    &:hover {
      background: $info;
      border-color: transparent;
      color: $white;
    }
  }

  .theme-color {
    transition: all 100ms ease;
    transform: scale(1);
    width: 3rem;
    height: 3rem;

    box-shadow: inset 2px 1px 0 rgba(0,0,0,.05), inset -2px -1px 0 rgba(0,0,0,.05);

    cursor: pointer;
    user-select: none;

    display: inline-block;
    position: relative;

    margin: 5px;
    border-radius: 5px;

    &--active {
      outline: 4px solid $light-blue;
      z-index: 2;
    }

    &--editable {
      .theme-color__edit__btn {
        display: flex;
        opacity: 0;
      }

      &:hover {
        transform: scale(1.15);
        box-shadow: 0 2px 4px rgba(0,0,0,.2);

        .theme-color__edit__btn {
          opacity: 1;
        }

        z-index: 3;
      }
    }

    &:active {
      transform: scale(0.95)
    }
  }

  .theme-color--new {
    font-size: 25px;
    box-shadow: none;
    small {
      font-size: 8px;
      text-transform: uppercase;
      line-height: 1;
      text-align: center;
    }

    &:hover {
      background: $blue;
      color: $white;
    }
  }

  .color-picker {
    width: 100%;
  }

  .color-picker-controls {
    width: 100%;
    margin-top: 10px;
    .el-button {
      width: 50%;
    }
  }

  .vue-color__chrome {
    box-shadow: none !important;
    margin: 0 auto;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    align-items: center;
    background: transparent !important;
  }

  .vue-color__chrome__chrome-body {
    background: transparent !important;
  }

  .site-settings-btns {
    padding-left: 2.4rem!important;
    padding-right: 2.4rem!important;
  }

</style>
